"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Af3956 = void 0;
const af3956_schema_1 = require("./af3956.schema");
const official_form_base_model_1 = require("../official-form-base-model");
class Af3956 extends official_form_base_model_1.OfficialFormBaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            art: false,
            memberDataRows: [],
        };
    }
    getSchema() {
        return af3956_schema_1.af3956Schema;
    }
}
exports.Af3956 = Af3956;
